module.exports = __webpack_public_path__ + "img/logo.92402c48.png";